import { Head, Link, useForm } from '@inertiajs/react'
import { ArrowLeft } from 'lucide-react'
import type { ReactNode } from 'react'

import { PageHeader } from '@/components/PageHeader'
import { Button } from '@/components/ui/button'
import { DashboardLayout } from '@/layouts/DashboardLayout'
import { foundersPath } from '@/lib/routes'

import {
  FounderFormFields,
  type CountryOption,
  type FounderFormData,
} from './_Form'

type FoundersNewProps = {
  countries: CountryOption[]
}

function FoundersNew({ countries }: FoundersNewProps) {
  const form = useForm<FounderFormData>({
    name: '',
    email: '',
    gender: '',
    linkedin_url: '',
    twitter_url: '',
    github_url: '',
    website_url: '',
    date_of_birth: '',
    country: '',
    kalio_id: null,
    avatar: null,
    remove_avatar: false,
  })

  return (
    <>
      <Head title="New founder" />

      <div className="mx-auto max-w-3xl px-8 py-10">
        <Link
          href={foundersPath()}
          className="mb-6 inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to founders
        </Link>

        <PageHeader
          title="New founder"
          description="Founders, operators, anyone you want to track by name."
        />

        <form
          onSubmit={(event) => {
            event.preventDefault()
            form.transform((data) => ({ founder: data }))
            form.post(foundersPath(), { forceFormData: true })
          }}
        >
          <FounderFormFields
            data={form.data}
            errors={form.errors as Partial<Record<keyof FounderFormData, string>>}
            setData={form.setData}
            countries={countries}
          />

          <div className="mt-6 flex justify-end gap-2">
            <Link href={foundersPath()}>
              <Button type="button" variant="ghost">
                Cancel
              </Button>
            </Link>
            <Button type="submit" disabled={form.processing}>
              {form.processing ? 'Saving…' : 'Create founder'}
            </Button>
          </div>
        </form>
      </div>
    </>
  )
}

export default Object.assign(FoundersNew, {
  layout: (page: ReactNode) => <DashboardLayout>{page}</DashboardLayout>,
})
